import { apiClient } from './api';

export class ExportService {
  static async downloadCsv(): Promise<void> {
    await apiClient.downloadFile('/api/export/csv', 'training_export.csv');
  }
}
